import { useState } from 'react'
import { useNavigate, Outlet } from 'react-router-dom'

import { useAuth } from '@App/components/AuthProvider/AuthProvider'
import InfoCarousel from '@App/components/InfoCarousel/InfoCarousel'

import './login.styl'

function Login() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [changedPasswordMessage, setChangedPasswordMessage] = useState('')

  if (user) {
    navigate('/')
  }

  return (
    <div className="login">
      <div className="login__pane">
        <InfoCarousel />
      </div>
      <div className="login__pane">
        <Outlet context={{ changedPasswordMessage, setChangedPasswordMessage }} />
      </div>
    </div>
  )
}

export default Login
